import { IAccessory } from './Accessories';

export const ACCESSORIES_LOAD_SUCCESS = 'ACCESSORIES_LOAD_SUCCESS';
export interface ISetAccessories {
  type: typeof ACCESSORIES_LOAD_SUCCESS;
  accessories: IAccessory[];
}

export type TAccessoriesActions = ISetAccessories;
